import { makeStateStore } from '@playcastdotio/StateStore';
import type { StateStore } from '@playcastdotio/CoreTypes';

export type RestartState = {
  scheduled: boolean;
  scheduledTimeUnix: number;
  lastError: string;
};

export function createRestartStore(): StateStore<RestartState> {
  return makeStateStore<RestartState>({
    scheduled: false,
    scheduledTimeUnix: 0,
    lastError: '',
  });
}
